export const packageFields = [
  {
    label: "Largo (*)",
    name: "package_length",
    endAdornment: "cm",
  },
  { label: "Ancho (*)", name: "package_width", endAdornment: "cm" },
  { label: "Alto (*)", name: "package_height", endAdornment: "cm" },
  {
    label: "Peso de producto empacado",
    name: "package_weight",
    endAdornment: "Kg",
  },
];

const productSizeAttributes = [
  {
    id: 1,
    category: "madera plastica",
    fields: [
      {
        label: "Largo",
        name: "length",
        endAdornment: "mts",
      },
      {
        label: "Ancho",
        name: "width",
        endAdornment: "mts",
      },
      {
        label: "Profundidad",
        name: "depth",
        endAdornment: "mts",
      },
      {
        label: "Altura",
        name: "height",
        endAdornment: "mts",
      },
      {
        label: "Diámetro",
        name: "diameter",
        endAdornment: "mts",
      },
      {
        label: "Peso",
        name: "weight",
        endAdornment: "Kg",
      },
    ],
    packageFields,
  },

  {
    id: 8,
    category: "revestimientos",
    fields: [
      {
        label: "Largo",
        name: "length",
        endAdornment: "mts",
      },
      {
        label: "Ancho",
        name: "width",
        endAdornment: "mts",
      },
      {
        label: "Espesor",
        name: "thickness",
        endAdornment: "cms",
      },
      {
        label: "Peso",
        name: "weight",
        endAdornment: "Kg",
      },
    ],
    packageFields,
  },

  {
    id: 10,
    category: "complementarios",
    fields: [
      {
        label: "Largo",
        name: "length",
        endAdornment: "mts",
      },
      {
        label: "Ancho",
        name: "width",
        endAdornment: "mts",
      },
      {
        label: "Profundidad",
        name: "depth",
        endAdornment: "mts",
      },
      {
        label: "Altura",
        name: "height",
        endAdornment: "mts",
      },
      {
        label: "Diámetro",
        name: "diameter",
        endAdornment: "mts",
      },
      {
        label: "Peso",
        name: "weight",
        endAdornment: "Kg",
      },
    ],
    packageFields,
  },
];

export default productSizeAttributes;
